import { render, staticRenderFns } from "./RoleAssignmentGrid.vue?vue&type=template&id=0aece44d"
import script from "./RoleAssignmentGrid.vue?vue&type=script&lang=js"
export * from "./RoleAssignmentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports